import Vue from 'vue'
import Router from 'vue-router'
import Companies from './views/Company/Companies.vue'
import CompanyDetails from './views/Company/CompanyDetails.vue'
import Login from './views/Login.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,

  routes: [
    { path: '/', redirect: '/companies' },
    {
      path: '/companies',
      name: 'companies',
      component: Companies,
      meta: { name: 'Företag' },
    },
    {
      path: '/companies/:id',
      name: 'companydetails',
      component: CompanyDetails,
      children: [
        {
          path: 'terminal/create',
          name: 'company.terminalcreate',
          component: () =>
            import(
              /* webpackChunkName: "terminals" */ './views/Terminal/TerminalCreate.vue'
            ),
          props: true,
        },
        {
          path: 'terminal/:terminalId',
          name: 'company.terminal',
          component: () =>
            import(
              /* webpackChunkName: "terminals" */ './views/Terminal/TerminalDetails.vue'
            ),
          props: true,
        },
        {
          path: 'sub/:subId',
          name: 'company.subdetails',
          component: () =>
            import(
              /* webpackChunkName: "companies" */ './views/Company/SubCompany.vue'
            ),
          props: true,
        },
      ],
    },
    {
      path: '/reports',
      name: 'reports',
      component: () =>
        import(/* webpackChunkName: "reports" */ './views/Reports/Index.vue'),
    },
    {
      path: '/products',
      name: 'products',
      component: () =>
        import(
          /* webpackChunkName: "products" */ './views/Product/Products.vue'
        ),
    },
    {
      path: '/products/create',
      name: 'product.create',
      component: () =>
        import(
          /* webpackChunkName: "products" */ './views/Product/ProductCreate.vue'
        ),
    },
    {
      path: '/products/:id',
      name: 'product.details',
      component: () =>
        import(
          /* webpackChunkName: "products" */ './views/Product/ProductDetails.vue'
        ),
    },

    {
      path: '/cashregisters',
      name: 'cashregisters',
      meta: { name: 'Kassaregister' },
      component: () =>
        import(
          /* webpackChunkName: "cashregisters" */ './views/Cashregister/Cashregisters.vue'
        ),
    },
    {
      path: '/cashregisters/:id',
      name: 'cashregisterdetails',
      meta: { name: 'Kassaregister' },
      component: () =>
        import(
          /* webpackChunkName: "cashregisters" */ './views/Cashregister/CashregisterDetails.vue'
        ),
    },
    {
      path: '/messages',
      component: () =>
        import(/* webpackChunkName: "messages" */ './views/Messages/Index.vue'),
      children: [
        {
          path: '',
          name: 'messages',
          redirect: { name: 'messages.create' },
        },
        {
          path: 'create',
          name: 'messages.create',
          component: () =>
            import(
              /* webpackChunkName: "messages" */ './views/Messages/Create.vue'
            ),
        },
        {
          path: 'archive',
          name: 'messages.archive',
          component: () =>
            import(
              /* webpackChunkName: "messages" */ './views/Messages/Archive.vue'
            ),
        },
      ],
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        public: true, // Allow access to even if not logged in
        onlyWhenLoggedOut: true,
      },
    },
    {
      path: '/about',
      name: 'about',

      component: () =>
        import(/* webpackChunkName: "about" */ './views/About.vue'),
    },
  ],
})

router.beforeEach((to, from, next) => {
  const isPublic = to.matched.some((record) => record.meta.public)
  const onlyWhenLoggedOut = to.matched.some(
    (record) => record.meta.onlyWhenLoggedOut,
  )
  const loggedIn = !!localStorage.getItem('voady-admin-token')

  if (!isPublic && !loggedIn) {
    return next({
      path: '/login',
      query: { redirect: to.fullPath }, // Store the full path to redirect the user to after login
    })
  }

  // Do not allow user to visit login page or register page if they are logged in
  if (loggedIn && onlyWhenLoggedOut) {
    return next('/')
  }

  next()
})

export default router
